#tabladefHome {
  min-height: 100dvh;
}

header,
main {
  box-sizing: border-box;
}

#tabladefHome header {
  position: sticky;
  top: 0;
  z-index: 10;
  width: 100%;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 0.5rem;
}
.header-container {
  position: relative;
  display: block;

  max-width: var(--root-max-content-width, 1600px);
  width: 100%;
  height: 100%;

  margin: 0 auto;
}
.header-container > .header-messages {
  position: absolute;
  display: block;

  left: 0;
  bottom: 0;

  width: auto;
  height: auto;
}

#tabladefHome main {
  height: calc(100dvh - 8.5rem);
  max-width: var(--root-max-content-width, 1600px);
  margin: 0 auto;
  padding: 0.5rem 0 0 0;
}

@media (max-width: 1600px) {
  #tabladefHome main {
    padding: 0.5rem 1rem 0 1rem;
  }
}
